import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import constant from "config/constant";
import { wrapBaseApi } from "util/apiWrapper";
import ls from "util/secureStorage";

// console.log("AUTH HEADER", _headers);

// Define a service using a base URL and expected endpoints
export const billsApi = createApi({
  reducerPath: "bills",
  // refetchOnReconnect: true,
  refetchOnMountOrArgChange: true,
  tagTypes: [],
  baseQuery: fetchBaseQuery({
    baseUrl: `${process.env.REACT_APP_WALLET_API_ENDPOINT}`,
    prepareHeaders: (headers, _) => {
      const auth = ls.get(constant.AUTH_TOKEN_KEY);

      headers.set("Authorization", auth.token);
      headers.set("Content-Type", "application/json");
      headers.set("Cache-Control", "no-cache, no-store, must-revalidate");
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getSupportedCountries: builder.query({
      query: (billType) => wrapBaseApi(`/wallet/bills/countries/${billType}`),
      transformResponse: (res) => res?.data,
    }),
    getDataPlans: builder.query({
      query: (country) => wrapBaseApi(`/wallet/bills/data-plans/${country}`),
      transformResponse: (res) => res?.data,
    }),
    getAirtimePlans: builder.query({
      query: (country) => wrapBaseApi(`/wallet/bills/topup-plans/${country}`),
      transformResponse: (res) => res?.data,
    }),
    getSellListingById: builder.query({
      query: (id) => wrapBaseApi(`/p2p/flexilisting/${id}/buy`),
      transformResponse: (res) => res?.data,
      // providesTags: ["BanksByCountry"],
    }),
    makeBill: builder.mutation({
      query: (input) => {
        return {
          url: wrapBaseApi(`/wallet/bills/airtime-topup`),
          method: "POST",
          body: input,
        };
      },
      transformResponse: (res) => res.data,
      // invalidatesTags: ["contractByTradeRef"],
    }),
    makeBillV2: builder.mutation({
      query: (input) => {
        return {
          url: wrapBaseApi(`/wallet/api/v2/bills/airtime-topup`),
          method: "POST",
          body: input,
        };
      },
      transformResponse: (res) => res.data,
      // invalidatesTags: ["contractByTradeRef"],
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints...

export const {
  useGetSupportedCountriesQuery,
  useGetDataPlansQuery,
  useGetAirtimePlansQuery,
  useMakeBillMutation,
  useMakeBillV2Mutation,
} = billsApi;

export default billsApi;
